export const cleanFiles = (files) => files.filter((f) => f !== null);

export const getDataQAForInput = (id, type) => {
  return {
    'data-field-type': type || 'text',
    'data-field-id': id,
  };
};
